import { Button, Container, Dropdown, Form, Modal } from "react-bootstrap"
import { Link, useNavigate, useLocation } from "react-router-dom"
import Logos from "../Logos"
import CommonSearch from "../CommonSearch"
import { MdOutlineFilterList } from "react-icons/md"
import { useEffect, useState } from "react"
import WebService from "../../Services/WebService"
import PhoneInput from "react-phone-input-2"
import HelperService from "../../Services/HelperService"
import { fuzzyFilter } from "../../utils/FuzzySearch"

const Header = ({ onSearch, selectedArea, useScrollableHeader }: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchArea, setSearchArea] = useState("");
    const [selectedAreas, setSelectedArea] = useState<any[]>([]);
    const [areaOptions, setAreaOptions] = useState([]);
    const hasActiveAreaFilters = selectedAreas.length > 0;
    const activeAreaFilters = areaOptions.filter((area: any) => selectedAreas.includes(area.id));

    // const areaOptions = ["Indoor", "Outdoor", "Pull area"];

    useEffect(() => {
        getAreaOptions();
    }, []);

    useEffect(() => {
        selectedArea(selectedAreas);
    }, [selectedAreas]);

    const getAreaOptions = () => {
        WebService.getAPI({
            action: "area/all",
            isHideToast: true,
            isHideError: true,
        })
            .then((res: any) => {
                if (res?.list?.length > 0) {
                    const areas = res.list.map((area: any) => ({
                        title: area.title,
                        id: area.id
                    }));
                    setAreaOptions(areas);
                }
            })
            .catch((err) => {
                console.error("Error fetching area options:", err);
            });
    }

    const handleBackClick = () => {
        if (location.pathname == "/item-list") {
            navigate("/menu", { state: { tableId: location.state?.tableId, tableNumber: location.state?.tableNumber } });
        } else {
            navigate(-1);
        }
    };

    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const handleLogoutClick = (e: any) => {
        e.preventDefault();
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        handleLogout();
    };

    const handleLogout = async () => {
        // console.log("fcm_token", localStorage.getItem('fcm_token'));
        setLoading(true);
        WebService.deleteAPI({
            action: "staffs/notification-token?notification_token=" + localStorage.getItem('fcm_token'),
            btnId: "logoutbtn",
        })
            .then((res: any) => {
                localStorage.clear();
                navigate('/login', { replace: true });
            }).catch((err: any) => {
                return;
            })
            .finally(() => setLoading(false));
    };

    const [showModal, setShowModal] = useState(false);
    const [step, setStep] = useState<'CHECK' | 'DETAILS' | 'OFFERS'>('CHECK');
    const [formData, setFormData] = useState({ mobile_number: '', dial_code: '', name: '' });
    const [loading, setLoading] = useState(false);
    const [rewards, setRewards] = useState<any[]>([]);

    const handleOfferClick = () => {
        setShowModal(true);
        setStep('CHECK');
        setFormData({ mobile_number: '', dial_code: '', name: '' });
        setRewards([]);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id === 'formMobileNumber' ? 'mobile_number' : 'name']: value
        }));
    };
    const [error, setError] = useState(false);
    const handleCheckCustomer = async (e: any) => {
        e.preventDefault();
        if (!formData.mobile_number) return;
        if (!formData.dial_code) return;

        setLoading(true);
        WebService.postAPI({
            action: 'waiter-order/check-customer',
            body: {
                dial_code: formData.dial_code,
                mobile_number: formData.mobile_number
            },
            isHideToast: true,
        })
            .then((res: any) => {
                setLoading(false);
                if (res.rewards) {
                    setRewards(res.rewards);
                }
                if (res.customer) {
                    handleAssignCustomer(res.customer.id, res.rewards || []);
                } else {
                    setStep('DETAILS');
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Check customer failed", err);
            });
    };

    const handleAddCustomer = async (e: any) => {
        e.preventDefault();
        if (!formData.name) return;

        setLoading(true);
        WebService.postAPI({
            action: 'waiter-order/add-customer',
            body: {
                mobile_number: formData.mobile_number,
                name: formData.name
            },
            isHideToast: true
        })
            .then((res: any) => {
                if (res.rewards) {
                    setRewards(res.rewards);
                }
                if (res.customer) {
                    handleAssignCustomer(res.customer.id, res.rewards || []);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error("Add customer failed", err);
            });
    };

    const handleAssignCustomer = (customerId: string, currentRewards: any[] = []) => {
        const orderId = location.state?.orderId;
        if (!orderId) {
            console.error("Order ID not found");
            return;
        }
        setLoading(true);
        WebService.postAPI({
            action: `waiter-order/assign-customer/${orderId}`,
            body: {
                customer_id: customerId
            },
            isHideToast: true
        })
            .then((res: any) => {
                setLoading(false);
                if (currentRewards.length > 0) {
                    setStep('OFFERS');
                } else {
                    setShowModal(false);
                }
                // Optionally show success toast if not handled by WebService
            })
            .catch((err) => {
                setLoading(false);
                console.error("Assign customer failed", err);
            });
    };


    const filteredAreas = fuzzyFilter(areaOptions, searchArea, ["title"]);

    if (["/cart/success", "/email-success"].includes(location.pathname)) {
        return null;
    }

    return (
        <>
            <header className={`site-header${useScrollableHeader ? " site-header--scrollable" : ""}`}>

                <div className="text-center mt-2 mb-3 d-flex justify-content-between align-items-center gap-3">
                    {!['/cart/success', '/home'].includes(location.pathname) ?
                        <div className="back" onClick={handleBackClick} style={{ cursor: 'pointer' }}>
                            <svg width="23" height="17" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.35776 6.75L6.68076 10.073C6.81926 10.2115 6.8901 10.3856 6.89326 10.5953C6.89643 10.8048 6.8256 10.982 6.68076 11.127C6.53593 11.2718 6.36026 11.3443 6.15376 11.3443C5.94743 11.3443 5.77185 11.2718 5.62701 11.127L1.13276 6.63275C1.0391 6.53909 0.973097 6.44034 0.934764 6.3365C0.896264 6.23267 0.877014 6.1205 0.877014 6C0.877014 5.8795 0.896264 5.76734 0.934764 5.6635C0.973097 5.55967 1.0391 5.46092 1.13276 5.36725L5.62701 0.873002C5.76551 0.734669 5.93951 0.663835 6.14901 0.660502C6.35868 0.657335 6.53593 0.728169 6.68076 0.873002C6.8256 1.018 6.89801 1.19367 6.89801 1.4C6.89801 1.60634 6.8256 1.782 6.68076 1.927L3.35776 5.25H16.75C16.9628 5.25 17.141 5.32184 17.2845 5.4655C17.4282 5.609 17.5 5.78717 17.5 6C17.5 6.21284 17.4282 6.391 17.2845 6.5345C17.141 6.67817 16.9628 6.75 16.75 6.75H3.35776Z" fill="white" />
                            </svg>
                        </div>
                        : <div></div>}
                    <Logos />
                    {location.pathname === '/payment-details' ? (
                        <div className="offer" onClick={handleOfferClick} style={{ cursor: 'pointer' }}>
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="22" cy="22" r="21.5" fill="white" stroke="#931314" />
                                <path d="M13.4586 30.3329V20.4995H13.3544C12.8974 20.4995 12.5088 20.3394 12.1887 20.0193C11.8686 19.6992 11.7085 19.3107 11.7085 18.8539V16.4996C11.7085 16.0428 11.8686 15.6543 12.1887 15.3342C12.5088 15.014 12.8974 14.854 13.3544 14.854H17.3107C17.1579 14.6776 17.0541 14.4789 16.9992 14.2579C16.9443 14.0371 16.9169 13.8051 16.9169 13.5621C16.9169 12.752 17.2005 12.0633 17.7676 11.4962C18.3347 10.9291 19.0233 10.6455 19.8335 10.6455C20.2488 10.6455 20.6335 10.7326 20.9878 10.9069C21.3419 11.0813 21.6585 11.3143 21.9376 11.6059C22.2167 11.3031 22.5334 11.0674 22.8877 10.8987C23.2418 10.7299 23.6264 10.6455 24.0417 10.6455C24.852 10.6455 25.5408 10.9291 26.1079 11.4962C26.675 12.0633 26.9586 12.752 26.9586 13.5621C26.9586 13.8024 26.9283 14.0309 26.8678 14.2476C26.8074 14.4643 26.7063 14.6664 26.5648 14.854H30.646C31.103 14.854 31.4915 15.014 31.8116 15.3342C32.1318 15.6543 32.2918 16.0428 32.2918 16.4996V18.8539C32.2918 19.3107 32.1318 19.6992 31.8116 20.0193C31.4915 20.3394 31.103 20.4995 30.646 20.4995H30.5417V30.3329C30.5417 30.8715 30.35 31.3326 29.9665 31.7161C29.583 32.0996 29.122 32.2913 28.5836 32.2913H15.4167C14.8783 32.2913 14.4174 32.0996 14.0339 31.7161C13.6504 31.3326 13.4586 30.8715 13.4586 30.3329ZM24.0417 12.2705C23.6757 12.2705 23.369 12.3943 23.1214 12.6418C22.8739 12.8894 22.7501 13.1961 22.7501 13.5621C22.7501 13.9281 22.8739 14.2349 23.1214 14.4824C23.369 14.7301 23.6757 14.854 24.0417 14.854C24.4077 14.854 24.7145 14.7301 24.9623 14.4824C25.2098 14.2349 25.3336 13.9281 25.3336 13.5621C25.3336 13.1961 25.2098 12.8894 24.9623 12.6418C24.7145 12.3943 24.4077 12.2705 24.0417 12.2705ZM18.5419 13.5621C18.5419 13.9281 18.6657 14.2349 18.9132 14.4824C19.1607 14.7301 19.4675 14.854 19.8335 14.854C20.1995 14.854 20.5062 14.7301 20.7538 14.4824C21.0013 14.2349 21.1251 13.9281 21.1251 13.5621C21.1251 13.1961 21.0013 12.8894 20.7538 12.6418C20.5062 12.3943 20.1995 12.2705 19.8335 12.2705C19.4675 12.2705 19.1607 12.3943 18.9132 12.6418C18.6657 12.8894 18.5419 13.1961 18.5419 13.5621ZM13.3335 16.4787V18.8748H21.1877V16.4787H13.3335ZM21.1877 30.6663V20.4995H15.0834V30.3329C15.0834 30.4302 15.1147 30.5101 15.1773 30.5726C15.2398 30.6351 15.3196 30.6663 15.4167 30.6663H21.1877ZM22.8127 30.6663H28.5836C28.6807 30.6663 28.7605 30.6351 28.823 30.5726C28.8856 30.5101 28.917 30.4302 28.917 30.3329V20.4995H22.8127V30.6663ZM30.6668 18.8748V16.4787H22.8127V18.8748H30.6668Z" fill="#931314" />
                            </svg>
                        </div>
                    ) :
                        <>
                            {/* {location.pathname == '/menu' && <div></div>}  */}
                            {location.pathname == '/home' ? <div className="back" onClick={handleLogoutClick} style={{ cursor: 'pointer' }}>
                                <svg width="35" height="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="22" cy="22" r="21.5" fill="white" stroke="#931314" />
                                    <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" fill="#931314" transform="translate(10, 10)" />
                                </svg>
                            </div> : <div></div>}
                            {/* <div></div> */}
                        </>
                    }

                </div>
                {!['/cart', '/cart/success', '/payment-details', '/payment-method', '/splitt-bill', '/receipt', '/email-receipt', '/email-success', '/qr-display'].includes(location.pathname) && (
                    <div className="page-header">
                        <div className="d-flex gap-3 align-items-center">
                            <div className="w-100">
                                <CommonSearch onSearch={(value: any) => onSearch(value)} />
                            </div>
                            {
                                !['/item-list', '/menu'].includes(location.pathname) &&
                                <Dropdown className="header-filter-dd">
                                    <Dropdown.Toggle
                                        variant="light"
                                        className={`filter-btn${hasActiveAreaFilters ? " filter-btn--active" : ""}`}
                                        id="dropdown-filter"
                                    >
                                        <MdOutlineFilterList size={18} />
                                        {hasActiveAreaFilters && (
                                            <span className="filter-btn__count">{selectedAreas.length}</span>
                                        )}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div style={{ padding: '12px 16px', minWidth: '250px' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h6 style={{ fontSize: '14px', fontWeight: 600, color: '#333' }}>
                                                    Select Area
                                                </h6>
                                                <Button size="sm" onClick={(e: any) => {
                                                    e.stopPropagation();
                                                    setSelectedArea([]);
                                                }}>Clear</Button>
                                            </div>
                                            <input
                                                type="text"
                                                placeholder="Search area..."
                                                value={searchArea}
                                                onChange={(e) => setSearchArea(e.target.value)}
                                                onClick={(e) => e.stopPropagation()}
                                                className="form-control"
                                            />

                                            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                {filteredAreas.map((area: any) => (
                                                    <div
                                                        key={area.id}
                                                        onClick={(e) => e.stopPropagation()}
                                                        style={{ padding: "4px 0" }}
                                                    >
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`area-${area.id}`}
                                                            label={area.title}
                                                            checked={selectedAreas.includes(area.id)}
                                                            onChange={() => {
                                                                if (selectedAreas.includes(area.id)) {
                                                                    setSelectedArea(selectedAreas.filter((id: any) => id !== area.id));
                                                                } else {
                                                                    setSelectedArea([...selectedAreas, area.id]);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            }
                        </div>
                        {hasActiveAreaFilters && !['/item-list', '/menu'].includes(location.pathname) && (
                            <div className="active-filter-strip">
                                <span className="active-filter-strip__label">Filtered by</span>
                                <div className="active-filter-strip__chips">
                                    {activeAreaFilters.map((area: any) => (
                                        <button
                                            key={area.id}
                                            type="button"
                                            className="active-filter-chip"
                                            onClick={() => setSelectedArea(selectedAreas.filter((id: any) => id !== area.id))}
                                        >
                                            {area.title}
                                            <span className="active-filter-chip__close">x</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <Modal show={showModal} onHide={handleCloseModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {step === 'OFFERS' ? 'Available Offer' : 'Recommendation'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {step !== 'OFFERS' ? (
                            <Form className="form-style" onSubmit={step === 'CHECK' ? handleCheckCustomer : handleAddCustomer}>
                                <Form.Group controlId="formMobileNumber" className="mb-3">
                                    <Form.Label>Mobile number</Form.Label>
                                    {/* <Form.Control 
                                        type="tel" 
                                        placeholder="Enter mobile number" 
                                        value={formData.mobile_number}
                                        onChange={handleInputChange}
                                        readOnly={step === 'DETAILS'}
                                    /> */}
                                    <PhoneInput
                                        specialLabel=""
                                        disabled={step === 'DETAILS'}
                                        containerStyle={{ width: "100%" }}
                                        inputStyle={{ width: "100%" }}
                                        country={"in"}
                                        value={formData.dial_code + formData.mobile_number}
                                        onChange={(p: any, phone: any) => {
                                            const mobile = HelperService.removeDialCodeFromMobile(
                                                p,
                                                phone.dialCode
                                            );

                                            setFormData({
                                                ...formData,
                                                mobile_number: mobile,
                                                dial_code: "+" + phone.dialCode,
                                            });

                                            if (error) setError(false);
                                        }}
                                    />
                                </Form.Group>

                                {step === 'DETAILS' && (
                                    <>
                                        <Form.Group className="text-center mb-3">
                                            <p className="font-16">Ohh! You are new customer. Please enter your name & mobile number to Recommendation</p>
                                        </Form.Group>
                                        <Form.Group controlId="formName" className="mb-4">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter your name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </>
                                )}

                                <Form.Group className=" ">
                                    <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                                        {loading ? 'Processing...' : step === 'CHECK' ? 'Check' : 'Submit'}
                                    </Button>
                                </Form.Group>
                            </Form>
                        ) : (
                            <div>
                                {rewards.map((reward, index) => (
                                    <div key={index} className="card shadow-sm border-0 mb-3" style={{ background: '#f8f9fa' }}>
                                        <div className="card-header border-0 text-white" style={{ background: '#D4A017' }}>
                                            <h6 className="mb-0">{reward.title}</h6>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">{reward.coupon_code}</h5>
                                            <p className="card-text text-muted my-2">
                                                {reward.description}
                                            </p>
                                            {/* <div className="text-center mt-3">
                                                <Button 
                                                    variant="link" 
                                                    className="text-warning text-decoration-none fw-bold p-0"
                                                    onClick={handleCloseModal}
                                                >
                                                    Apply
                                                </Button>
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                                {rewards.length === 0 && <p className="text-center">No offers available.</p>}
                            </div>
                        )}
                    </Modal.Body>
                </Modal>

                <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Logout</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to logout?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowLogoutModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={confirmLogout}>
                            Logout
                        </Button>
                    </Modal.Footer>
                </Modal>
            </header>
        </>
    )
}
export default Header;
